module.exports = __webpack_public_path__ + "static/media/2-schrodingers-sky.cb93148.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/altcoin/2-schrodingers-sky.mp3
// module id = AqEx
// module chunks = 0